module.exports = __webpack_public_path__ + "img/hardhat.7d81ca1a.png";